export default __webpack_public_path__ + "static/media/Facebook.b15396ce.svg";